/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemMailAddressInputFormatLocalPart } from './formPagePropertyItemMailAddressInputFormatLocalPart';
import { FormPagePropertyItemMailAddressInputFormatAtSignSeparatedDomain } from './formPagePropertyItemMailAddressInputFormatAtSignSeparatedDomain';


/**
 * メールアドレス(ローカルパートとドメイン別入力)
 */
export interface FormPagePropertyItemMailAddressInputFormatAtSignSeparated { 
    /**
    * 入力形式を定める文字列
    */
    inputType: 'atSignSeparated';
    local: FormPagePropertyItemMailAddressInputFormatLocalPart;
    /**
    * ローカルパート、ドメイン部分の区切り文字
    */
    delimiter: FormPagePropertyItemMailAddressInputFormatAtSignSeparated.DelimiterEnum;
    domain: FormPagePropertyItemMailAddressInputFormatAtSignSeparatedDomain;
}

export namespace FormPagePropertyItemMailAddressInputFormatAtSignSeparated {
    export type DelimiterEnum = '@';
    export const DelimiterEnum = {
        AtMark: '@' as DelimiterEnum
    };
}


